import React, { useEffect, useRef, useState } from 'react';
import { arrayOf, element, func, string, shape, bool, oneOf } from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

import MultiSelect from './MultiSelect';

const OuterWrapper = styled.div`
  background: transparent;
  color: #444;
  width: fit-content;
  display: inline-block;
  position: relative;
  button {
    background: #fff;
    border: 1px solid #dfe3ec;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 8px 12px;
    color: #33373d;
    font-size: 14px;
    line-height: 16px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    svg {
      margin-left: 8px;
    }
  }
  button:focus {
    outline: none;
  }
`;

const DropdownMultiSelect = ({
  onClick,
  options,
  type,
  srMessage,
  position,
  id,
  additionalInformationNode,
  buttonText
}) => {
  const [show, setShow] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOut = event => {
      if (!dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    document.addEventListener('mousedown', handleClickOut);

    return () => {
      document.removeEventListener('mousedown', handleClickOut);
    };
  }, [dropdownRef]);

  return (
    <OuterWrapper id={id} ref={dropdownRef}>
      <button onClick={() => setShow(!show)} id={`manage-${srMessage}`}>
        {buttonText || 'Manage'}
        <FontAwesomeIcon icon={faChevronDown} />
      </button>
      {show && (
        <MultiSelect
          onClick={onClick}
          options={options}
          type={type}
          srMessage={srMessage}
          position={position}
          additionalInformationNode={additionalInformationNode}
        />
      )}
    </OuterWrapper>
  );
};

DropdownMultiSelect.propTypes = {
  onClick: func,
  options: arrayOf(
    shape({
      id: string,
      label: string,
      checked: bool
    })
  ).isRequired,
  type: oneOf(['checkbox', 'radio']),
  srMessage: string,
  id: string,
  onChecked: func,
  position: string,
  additionalInformationNode: element,
  buttonText: string
};

export default DropdownMultiSelect;
